<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="clearfix flex justify-between">
          <h5><span>{{$t('addReportCustomComponentRel.associate')}}</span></h5>
        </div>
        <div class="card-body">
          <el-form label-width="120px">
            <el-form-item :label="$t('addReportCustomComponentRel.component')">
              <el-col :span="18">
                <el-input 
                  v-model="addReportCustomComponentRelInfo.name" 
                  disabled 
                  :placeholder="$t('addReportCustomComponentRel.componentRequired')">
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-button 
                  type="primary" 
                  @click="chooseReportComponent()"
                  style="float: right;">
                  {{$t('addReportCustomComponentRel.chooseComponent')}}
                </el-button>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('addReportCustomComponentRel.componentSeq')">
              <el-input 
                v-model="addReportCustomComponentRelInfo.seq" 
                :placeholder="$t('addReportCustomComponentRel.seqRequired')">
              </el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right; margin-top: 20px;">
            <el-button 
              type="warning" 
              @click="_closeAddReportCustomComponentRelInfo()"
              style="margin-right: 20px;">
              {{$t('common.cancel')}}
            </el-button>
            <el-button 
              type="primary" 
              @click="saveReportCustomComponentRelInfo()">
              <i class="el-icon-check"></i>
              {{$t('common.save')}}
            </el-button>
          </div>
        </div>
      </el-card>
    </el-col>
    <choose-report-custom-component ref="chooseReportCustomComponent"></choose-report-custom-component>
  </el-row>
</template>

<script>
import { saveReportCustomComponentRel } from '@/api/dev/reportCustomComponentRelApi'
import ChooseReportCustomComponent from '@/components/dev/chooseReportCustomComponent/chooseReportCustomComponent'

export default {
  name: 'AddReportCustomComponentRel',
  components: {
    ChooseReportCustomComponent
  },
  data() {
    return {
      addReportCustomComponentRelInfo: {
        relId: '',
        componentId: '',
        name: '',
        customId: '',
        seq: ''
      }
    }
  },
  methods: {
    open(params) {
      this.addReportCustomComponentRelInfo.customId = params.customId
    },
    addReportCustomComponentRelValidate() {
      return this.$validate.validate({
        addReportCustomComponentRelInfo: this.addReportCustomComponentRelInfo
      }, {
        'addReportCustomComponentRelInfo.componentId': [
          {
            limit: "required",
            param: "",
            errInfo: this.$t('addReportCustomComponentRel.componentRequired')
          },
          {
            limit: "maxLength",
            param: "30",
            errInfo: this.$t('addReportCustomComponentRel.componentMaxLength')
          },
        ],
        'addReportCustomComponentRelInfo.customId': [
          {
            limit: "required",
            param: "",
            errInfo: this.$t('addReportCustomComponentRel.reportIdRequired')
          },
          {
            limit: "maxLength",
            param: "30",
            errInfo: this.$t('addReportCustomComponentRel.reportIdMaxLength')
          },
        ],
        'addReportCustomComponentRelInfo.seq': [
          {
            limit: "required",
            param: "",
            errInfo: this.$t('addReportCustomComponentRel.seqRequired')
          },
          {
            limit: "maxLength",
            param: "11",
            errInfo: this.$t('addReportCustomComponentRel.seqMaxLength')
          },
        ],
      })
    },
    async saveReportCustomComponentRelInfo() {
      if (!this.addReportCustomComponentRelValidate()) {
        this.$message.error(this.$validate.errInfo)
        return
      }

      try {
        const res = await saveReportCustomComponentRel(this.addReportCustomComponentRelInfo)
        if (res.code === 0) {
          this.clearAddReportCustomComponentRelInfo()
          this.$emit('listReportCustomComponentRel')
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败处理', error)
        this.$message.error(error)
      }
    },
    _closeAddReportCustomComponentRelInfo() {
      this.$emit('listReportCustomComponentRel')
    },
    clearAddReportCustomComponentRelInfo() {
      this.addReportCustomComponentRelInfo = {
        componentId: '',
        customId: '',
        seq: '',
        name: ''
      }
    },
    chooseReportComponent() {
      this.$refs.chooseReportCustomComponent.open(this.addReportCustomComponentRelInfo)
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
</style>